import { AlertTriangle, RotateCcw } from "lucide-react";
import { Component, type ReactNode } from "react";

interface Props {
	children: ReactNode;
	fallback?: ReactNode;
}

interface State {
	hasError: boolean;
	error?: Error;
}

export class ErrorBoundary extends Component<Props, State> {
	state: State = { hasError: false };

	static getDerivedStateFromError(error: Error): State {
		return { hasError: true, error };
	}

	render() {
		if (this.state.hasError) {
			if (this.props.fallback) return this.props.fallback;
			return (
				<div className="flex flex-col items-center justify-center h-full p-8 text-center">
					<AlertTriangle className="w-12 h-12 text-destructive mb-4" />
					<h2 className="text-lg font-semibold mb-2">Something went wrong</h2>
					<p className="text-sm text-muted-foreground mb-6 max-w-sm">
						{this.state.error?.message || "An unexpected error occurred."}
					</p>
					<button
						type="button"
						onClick={() => window.location.reload()}
						className="inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-primary text-primary-foreground text-sm font-medium hover:bg-primary/90 transition-colors"
					>
						<RotateCcw className="w-4 h-4" />
						Reload page
					</button>
				</div>
			);
		}
		return this.props.children;
	}
}
